import React from 'react';
import { Check } from 'lucide-react';

const SUPPORT_URL = 'https://t.me/fitlinezsupport';

export default function PaymentSuccess() {
  return (
    <main dir="rtl" className="flex min-h-screen items-center justify-center bg-[#f3efe7] px-5 py-12 text-[#18211f]">
      <section className="w-full max-w-lg rounded-[2rem] border border-[#1c2c29]/10 bg-white/80 p-8 text-center shadow-[0_24px_80px_rgba(28,44,41,0.09)] sm:p-12">
        <div className="mx-auto mb-6 grid h-16 w-16 place-items-center rounded-full bg-[#e8f3ec] text-[#34704f]">
          <Check size={32} strokeWidth={2.5} aria-hidden="true" />
        </div>
        <p className="mb-3 text-sm font-bold text-[#638176]">آکادمی آزی</p>
        <h1 className="text-3xl font-black tracking-tight sm:text-4xl">پرداخت موفقیت‌آمیز بود</h1>
        <p className="mx-auto mt-4 max-w-sm text-base leading-8 text-[#5b6561]">
          از اعتمادتون ممنونیم. برای ادامه فرایند ثبت‌نام و راهنمایی مراحل بعدی، با پشتیبانی در تلگرام در ارتباط باشید.
        </p>
        <a
          href={SUPPORT_URL}
          target="_blank"
          rel="noreferrer"
          className="mt-8 inline-flex min-h-14 w-full items-center justify-center rounded-2xl bg-[#df6b52] px-6 py-4 font-extrabold text-white shadow-[0_14px_30px_rgba(223,107,82,0.22)] transition hover:-translate-y-0.5 hover:bg-[#c95d47] focus:outline-none focus:ring-4 focus:ring-[#df6b52]/25"
        >
          ادامه ثبت‌نام در تلگرام پشتیبانی
        </a>
      </section>
    </main>
  );
}
